import axios from "../../../core/api/http-common";

const ON_GET_USER_SETTINGS = "/users/get/settings";
export function onGetUserSettings(axiosPrivate, data, signal) {
  const _data = {
    user_id: data?.user_id,
    sys_role: data?.sys_role,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .get(ON_GET_USER_SETTINGS, { params: _data, signal: signal })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const NEW_LOGIN = "/auth/new/login";
export function onNewlogin(axiosPrivate, data) {
  //
  const login_id = data?.login_id;
  const user_infos = data?.user_infos;
  const next_inscription = data?.next_inscription;
  const dates = data?.dates;
  const location = "N/A";
  const latitude = "N/A";
  const longitude = "N/A";
  const device = "PC";
  const ip_address = "N/A";
  const operating_system = "N/A";
  const navigator = "N/A";
  //
  const _data = {
    login_id: login_id,
    user_infos: user_infos,
    next_inscription: next_inscription,
    dates: dates,
    is_channel: "webApp",
    location: location,
    latitude: latitude,
    longitude: longitude,
    device: device,
    ip_address: ip_address,
    operating_system: operating_system,
    navigator: navigator,
  };
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(NEW_LOGIN, _data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const ON_NEW_SUBSCRIPTION = "/auth/new/subscription";
export function onNewSubscription(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_NEW_SUBSCRIPTION, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const ON_UPDATE_PASSWORD = "/auth/change/password";
export function onChangePassword(axiosPrivate, data) {
  return new Promise(async (resolve, reject) => {
    await axiosPrivate
      .post(ON_UPDATE_PASSWORD, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}


